/* KK product page helpers. Never replaces Horizon nodes that hold data-* children. */

const cfg = document.querySelector('[data-kk-pdp]');

/* Size guide link → open the Size guide row and bring it into view. */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-kk-open]');
  if (!btn) return;
  const target = document.getElementById(btn.dataset.kkOpen);
  if (!target) return;
  target.open = true;
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  target.classList.add('is-flash');
  setTimeout(() => target.classList.remove('is-flash'), 1600);
});

/* Horizon's sticky bar prints the raw title (with emojis); show the tidy one instead.
   The title <p> holds plain text only, so swapping its text is safe. */
function tidyStickyTitle() {
  const tidy = document.querySelector('.kk-pdp-title__h')?.textContent.trim();
  const p = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__title');
  if (tidy && p && !p.children.length && p.textContent.trim() !== tidy) p.textContent = tidy;
}
tidyStickyTitle();
customElements.whenDefined('sticky-add-to-cart').then(tidyStickyTitle);

/* After Add to cart on the product page, open the cart drawer (shows the Fastrr BUY NOW). */
if (cfg?.dataset.openCart === 'true') {
  document.addEventListener('cart:update', (e) => {
    const d = e.detail?.data;
    if (!d || d.didError || d.source !== 'product-form-component') return;
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') setTimeout(() => drawer.open(), 300);
  });
}

/* Prepaid vs COD cards: select on tap; keep prices in step with the selected size. */
document.addEventListener('click', (e) => {
  const opt = e.target.closest('[data-kk-pay-opt]');
  if (!opt) return;
  opt.closest('[data-kk-pay]').querySelectorAll('[data-kk-pay-opt]').forEach((c) => {
    const on = c === opt;
    c.classList.toggle('is-on', on);
    c.setAttribute('aria-checked', on);
  });
});
(function payPrices() {
  const box = document.querySelector('[data-kk-pay]');
  const src = document.querySelector('.product-details product-price');
  if (!box || !src) return;
  const fmtEl = document.querySelector('[data-kk-cart-cfg]');
  const fmt = (paise) => (fmtEl?.dataset.moneyFormat || '₹{{amount}}')
    .replace(/\{\{\s*[\w_]+\s*\}\}/, new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(paise / 100)));
  const off = Number(box.dataset.off || 0);
  const sync = () => {
    const t = src.querySelector('.price')?.textContent || '';
    const n = Math.round(parseFloat(t.replace(/[^\d.]/g, '').replace(/^\./, '')) * 100);
    if (!n) return;
    box.querySelector('[data-kk-pay-pre]').textContent = fmt(Math.max(0, n - off));
    box.querySelector('[data-kk-pay-mrp]').textContent = fmt(n);
    box.querySelector('[data-kk-pay-cod]').textContent = fmt(n);
  };
  new MutationObserver(sync).observe(src, { childList: true, subtree: true, characterData: true });
})();

/* BUY NOW under the payment cards: presses the page's own Fastrr button (fallback: Add to cart). */
document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-kk-pay-buy]')) return;
  const sr = document.querySelector('.product-details .shiprocket-headless .sr-headless-checkout');
  if (sr) { sr.click(); return; }
  document.querySelector('.product-details add-to-cart-component button[type="submit"]')?.click();
});

/* Tag the buy box + its section so the white-card styles don't depend on :has() (older Safari/Firefox). */
(function tagBuyBox() {
  const anchor = document.querySelector('.product-details .buy-buttons-block, .product-details product-form-component, .product-details variant-picker');
  const box = anchor?.closest('.group-block');
  if (box) box.classList.add('kk-buybox');
  document.querySelector('.product-information')?.closest('.shopify-section')?.classList.add('kk-pdp-sec');
})();
